module.exports = __webpack_public_path__ + "static/knotheadbandpk-8048ea84456f619ded85f076e13f801c.jpeg";